import {cloneDeep, sortBy} from 'lodash';
import {
	concatMergeStrategy,
	deleteRelationship,
	isApiResponseOk,
	lastOneWinsMergeStrategy,
	normalize,
	normalizedCreate,
	normalizedDelete,
	normalizedUpdate,
	truthyWinsMergeStrategy
} from '../../util/utils';
import {
	entities,
	itControlApproachType,
	specialBodiesSlices,
	HttpStatusCodes,
	TaskStatusIds,
	inherentRiskTypeId,
	reviewNoteStatus,
	updateAnnotationAction
} from '../../util/uiconstants';
import {
	BODIES_SPECIAL_CLIENTSIDE_FILTERS,
	ADD_ENTITY_DOCUMENT_SIGNOFF,
	CREATE_ENTITY_FORM,
	CREATE_ITAPPLICATION_ITPROCESS_RELATIONSHIP,
	CREATE_ITAPPLICATION_SO,
	CREATE_ITCONTROL,
	CREATE_IT_SO,
	CREATE_ITPROCESS,
	CREATE_ITRISK,
	CREATE_RISK,
	CREATE_SCOT,
	DELETE_ITAPPLICATION,
	DELETE_ITAPPLICATION_ITPROCESS_RELATION,
	DELETE_ITCONTROL,
	DELETE_ITPROCESS,
	DELETE_ITRISK,
	DELETE_RISK,
	DELETE_SCOT,
	GET_ALL_ITCONTROLS,
	GET_ALL_ITPROCESSES,
	GET_ALL_ITPROCESSES_WITHOUT_PAGINATION,
	GET_ALL_IT_APPLICATIONS,
	GET_ALL_SCOTS,
	GET_ALL_TASKS,
	ADD_RELATED_TASK,
	GET_ENGAGEMENT_ALL_ITCONTROLS,
	GET_ENGAGEMENT_ALL_SCOTS,
	GET_ITCONTROL_BY_ID,
	GET_IT_APPLICATION,
	GET_ITAPPSO_BY_ID,
	GET_IT_SO_BY_ID,
	GET_RISKS,
	GET_RISKS_FACTORS,
	GET_RISK_TYPES,
	IT_APPLICATION_SELECTED,
	IT_PROCESS_SELECTED,
	POST_RNH_NEW_NOTE,
	REFRESH_UNRELATED_ITCONTROLS,
	RELATE_ITRISK_ITCONTROL,
	RELATE_TASK_ITPROCESS,
	REMOVE_ENTITY_DOCUMENT_SIGNOFF,
	UNRELATE_ITRISK_ITCONTROL,
	UNRELATE_TASK_ITPROCESS,
	UPDATE_CONTROL,
	UPDATE_DOCUMENT,
	UPDATE_ITAPPLICATION,
	UPDATE_ITCONTROL,
	UPDATE_IT_SO,
	UPDATE_ITPROCESS,
	UPDATE_ITRISK,
	UPDATE_RNH_NOTE_DETAIL,
	UPDATE_RISK_FACTOR_RELATION,
	UPDATE_SCOT,
	UPDATE_RISK,
	PUT_WCGW,
	GET_FORM_BODIES_BY_SECTIONID,
	UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE,
	GET_ITPROCESS_BY_ID,
	GET_CONTROL_BY_ID,
	CREATE_ITPROCESS_SUPPORTING_ITAPPLICATION_RELATIONSHIP,
	DELETE_ITPROCESS_SUPPORTING_ITAPPLICATION_RELATIONSHIP,
	GET_ALL_CRA_ACCOUNTS,
	GET_ALL_IT_APPS,
	GET_ALL_IT_APPS_SO,
	GET_TECHNOLOGY_DETAILS,
	DELETE_IT_APPS_BY_ID_SO,
	DELETE_IT_APPS_BY_ID,
	UPDATE_MANAGE_ACCOUNT,
	UPDATE_ASSERTION_IR_CR,
	PATCH_ACCOUNT_RATIONALE,
	GET_CRA_ORPHANED_RISKS_COUNT,
	PATCH_RISK,
	GET_SAD_ENTITY_LISTING_FOR_BODY
} from '../../actions/actiontypes';
import {
	normalizeScots,
	normalizeItProcesses,
	normalizeItApplications,
	normalizeItControls,
	normalizeRiskTypes,
	normalizeRisks,
	normalizeRiskFactors,
	normalizeEntities,
	normalizeControls,
	getChildrenNormalize,
	getMergeStrategy,
	normalizeITSOApplications
} from '../Common/bodiesSpecial';
import {applyEntityDocumentUpdate} from './normalizers/entityDocumentsUpdateHelper';
import initialstate from '../initialstate';

const deleteItApplicationFromState = ({allIds, byId}, itApplicationId) => {
	return {
		allIds: allIds.filter((id) => id !== Number(itApplicationId)),
		byId: _.omit(byId, itApplicationId)
	};
};

export default function reducer(state = initialstate.bodiesSpecial, action) {
	let updatedState;

	switch (action.type) {
		case GET_ALL_SCOTS: {
			if (action.responseObj && action.responseObj.status === HttpStatusCodes.Ok) {
				return {
					...normalizeScots(action.response.data, state),
					metadata: getMetadata(
						state,
						action.response.data,
						action.bodyId,
						action.entityId,
						action.response.page,
						action.response.pages,
						action.response.totalEntityCount,
						action.clientFilters
					)
				};
			}
			return state;
		}

		case GET_ENGAGEMENT_ALL_SCOTS: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			const scots = action.response.data.map((scot) => ({
				...scot,
				controls: scot.controls?.map((control) => control.id) || [],
				itApplications: scot.itApplications?.map((itApplication) => itApplication.id) || []
			}));

			const controls = action.response.data
				.flatMap((scot) => scot.controls || [])
				.map((control) => {
					const relatedScots = scots.filter((scot) => scot.controls?.some((id) => id === control.id)).map((scot) => scot.id);

					return {
						...control,
						itApplications: control.itApplications?.map((itApplication) => itApplication.id) || [],
						scots: relatedScots || []
					};
				});

			const metadata = {
				...state.metadata,
				[action.isServiceOrganization ? 'allSoSCOTs' : 'allITAppSCOTs']: [...scots.map((scot) => scot.id)]
			};

			return {
				...state,
				metadata,
				scots: normalize(scots, undefined, state.scots, truthyWinsMergeStrategy),
				controls: normalize(controls, 'id', state.controls, truthyWinsMergeStrategy)
			};
		}

		case GET_ALL_ITPROCESSES: {
			if (action.response && action.response.data) {
				return {
					...normalizeItProcesses(action.response.data, state),
					metadata: getMetadata(
						state,
						action.response.data,
						action.bodyId,
						action.entityId,
						action.response.page,
						action.response.pages,
						action.response.totalEntityCount,
						action.clientFilters
					)
				};
			} else {
				return state;
			}
		}

		case GET_ITPROCESS_BY_ID: {
			if (action.response) {
				return {
					...normalizeItProcesses([action.response], state)
				};
			} else {
				return state;
			}
		}

		case REFRESH_UNRELATED_ITCONTROLS: {
			const {bodyId} = action;

			const refreshCounter = state.metadata[bodyId].refreshItControlCounter || false;

			return {
				...state,
				metadata: {
					...state.metadata,
					[bodyId]: {
						...state.metadata[bodyId],
						// This property exists only to force the unrelated It Control counter to refresh
						refreshItControlCounter: !refreshCounter
					}
				}
			};
		}

		case GET_SAD_ENTITY_LISTING_FOR_BODY: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			const data = action.response?.data || [];

			return {
				...state,
				listingEntities: normalize(data, undefined, state.listingEntities, lastOneWinsMergeStrategy),
				metadata: getMetadata(
					state,
					data,
					action.bodyId,
					action.entityId,
					action.response?.page,
					action.response?.pages,
					action.response?.totalEntityCount,
					action.clientFilters
				)
			};
		}

		case CREATE_ENTITY_FORM: {
			// Scope the update to the body that triggered the create so a create-entity-form
			// from any other body/slice can never ambiguously mutate this body's listing state.
			const bodyMetadata = action.bodyId !== null && action.bodyId !== undefined ? state.metadata?.[action.bodyId] : undefined;
			if (!isApiResponseOk(action) || !Array.isArray(action.response) || !state.listingEntities?.byId || !bodyMetadata) {
				return state;
			}

			const bodyEntityIds = new Set((bodyMetadata.allIds || []).map(Number));
			const createdDocuments = action.response.filter(
				(item) =>
					item?.isSuccess &&
					item?.document &&
					item?.entityObjectId !== null &&
					item?.entityObjectId !== undefined &&
					bodyEntityIds.has(Number(item.entityObjectId))
			);
			if (createdDocuments.length === 0) {
				return state;
			}

			let hasChanges = false;
			const updatedById = {...state.listingEntities.byId};

			createdDocuments.forEach((item) => {
				const entity = updatedById[item.entityObjectId];
				if (!entity) {
					return;
				}

				// Mirror the collection precedence used by the listing (relatedDocuments first, then objectRelatedDocuments).
				const collectionKey = Array.isArray(entity.relatedDocuments) ? 'relatedDocuments' : 'objectRelatedDocuments';
				const existingDocuments = Array.isArray(entity[collectionKey]) ? entity[collectionKey] : [];

				if (existingDocuments.some((document) => document?.id === item.document.id)) {
					return;
				}

				updatedById[item.entityObjectId] = {
					...entity,
					[collectionKey]: [...existingDocuments, item.document]
				};
				hasChanges = true;
			});

			if (!hasChanges) {
				return state;
			}

			return {
				...state,
				listingEntities: {
					...state.listingEntities,
					byId: updatedById
				}
			};
		}

		case UPDATE_DOCUMENT: {
			if (action.error || !action.documentId || !action.meta?.api?.data) {
				return state;
			}

			return applyEntityDocumentUpdate(state, action, action.documentId, (document) => ({
				...document,
				...action.meta.api.data
			}));
		}

		case ADD_ENTITY_DOCUMENT_SIGNOFF: {
			if (action.error || !action.documentId || !action.documentSignoff) {
				return state;
			}

			return applyEntityDocumentUpdate(state, action, action.documentId, (document) => ({
				...document,
				approvals: [...(document.approvals || []), action.documentSignoff]
			}));
		}

		case REMOVE_ENTITY_DOCUMENT_SIGNOFF: {
			if (action.error || !action.documentId || !action.approvalId) {
				return state;
			}

			return applyEntityDocumentUpdate(state, action, action.documentId, (document) => ({
				...document,
				approvals: (document.approvals || []).filter((approval) => approval.id !== action.approvalId)
			}));
		}

		case POST_RNH_NEW_NOTE: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			const documentId = action?.meta?.api?.data?.documentId;
			if (!documentId) {
				return state;
			}

			return applyEntityDocumentUpdate(state, action, documentId, (document) => ({
				...document,
				engagementReviewNoteCount: (document.engagementReviewNoteCount || 0) + 1
			}));
		}

		case UPDATE_RNH_NOTE_DETAIL: {
			if (!isApiResponseOk(action) || action?.data?.updateAction !== updateAnnotationAction.bulkStatusUpdate) {
				return state;
			}

			const {documentId, statusIdChanged, isOpening} = action.data;
			if (!documentId) {
				return state;
			}

			return applyEntityDocumentUpdate(state, action, documentId, (document) => {
				let engagementReviewNoteCount = document.engagementReviewNoteCount || 0;

				if (statusIdChanged && isOpening) {
					engagementReviewNoteCount += 1;
				} else if (action.previousStatusId === reviewNoteStatus.Open.id) {
					engagementReviewNoteCount -= 1;
				}

				return {
					...document,
					engagementReviewNoteCount
				};
			});
		}

		case BODIES_SPECIAL_CLIENTSIDE_FILTERS: {
			const {bodyId, entityName, filters} = action;

			const filtersArray = sortBy(Object.entries(filters), (filter) => {
				return filterPriority[filter[0]];
			});
			let filteredIds = null;
			if (filtersArray.length > 0) {
				filteredIds = filterFunctions[filtersArray[0][0]](state, state.metadata[bodyId]?.allIds, entityName, filtersArray[0][1]);
				for (let i = 1; i < filtersArray.length; i++) {
					filteredIds = filterFunctions[filtersArray[i][0]](state, filteredIds, entityName, filtersArray[i][1]);
				}
			}

			return {
				...state,
				metadata: {
					...state.metadata,
					[bodyId]: {
						...state.metadata[bodyId],
						filteredIds: filteredIds
					}
				}
			};
		}

		case GET_IT_APPLICATION:
		case GET_ITAPPSO_BY_ID:
			{
				if (isApiResponseOk(action)) {
					if (action.response.data) {
						if (!action.bodyId) {
							return {
								...normalizeItApplications(action.response.data, state)
							};
						}
						return {
							...normalizeItApplications(action.response.data, state),
							metadata: getMetadata(
								state,
								action.response.data,
								action.bodyId,
								action.entityId,
								action.response.page,
								action.response.pages,
								action.response.totalEntityCount,
								action.clientFilters
							)
						};
					}
				} else if (action.meta?.api?.data) {
					return {
						...state,
						itApplications: deleteItApplicationFromState(state.itApplications, action.meta?.api?.data)
					};
				}
			}
			return state;
		case GET_ALL_IT_APPLICATIONS:
			{
				if (action.response.data) {
					// Create a fresh state for IT Applications (don't merge with previous)
					const freshState = {
						...state,
						itApplications: {byId: {}, allIds: []}
					};
					const normalized = normalizeItApplications(action.response.data, freshState);

					if (!action.bodyId) {
						// Store pagination info even when there's no bodyId
						return {
							...normalized,
							itApplications: {
								...normalized.itApplications,
								page: action.response.page || 1,
								pages: action.response.pages || 1,
								totalEntityCount: action.response.totalEntityCount || 0
							}
						};
					}
					return {
						...normalized,
						metadata: getMetadata(
							state,
							action.response.data,
							action.bodyId,
							action.entityId,
							action.response.page,
							action.response.pages,
							action.response.totalEntityCount,
							action.clientFilters
						)
					};
				}
			}
			return state;
		case GET_IT_SO_BY_ID:
			{
				if (isApiResponseOk(action)) {
					if (action.response.data) {
						if (!action.bodyId) {
							return {
								...normalizeITSOApplications(action.response.data, state)
							};
						}
						return {
							...normalizeITSOApplications(action.response.data, state),
							metadata: getMetadata(
								state,
								action.response.data,
								action.bodyId,
								action.entityId,
								action.response.page,
								action.response.pages,
								action.response.totalEntityCount,
								action.clientFilters
							)
						};
					}
				} else if (action.meta?.api?.data) {
					return {
						...state,
						itsoApplications: deleteItApplicationFromState(state.itsoApplications, action.meta?.api?.data)
					};
				}
			}
			return state;

		case CREATE_SCOT: {
			if (!action.response || action.error) {
				return state;
			}

			const scotResponse = {
				...action.response
			};

			return {
				...state,
				scots: normalizedCreate(state.scots, scotResponse)
			};
		}

		case DELETE_SCOT: {
			if (action.responseObj?.status === HttpStatusCodes.NoContent || action.error?.response?.status === HttpStatusCodes.NotFound) {
				return {
					...state,
					scots: normalizedDelete(state.scots, action.scotId)
				};
			}
			return state;
		}

		case DELETE_ITAPPLICATION: {
			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, action.itApplicationId, entities.ItSoApplication)
			};

			result.controls = deleteRelationship(result.controls, 'itApplications', action.itApplicationId);
			result.itProcesses = deleteRelationship(result.itProcesses, 'itApplications', action.itApplicationId);
			result.scots = deleteRelationship(result.scots, 'itApplications', action.itApplicationId);

			result.itApplications = normalizedDelete(result.itApplications, action.itApplicationId);

			return result;
		}

		case DELETE_ITAPPLICATION_ITPROCESS_RELATION: {
			if (!action.error && state.itApplications && state.itProcesses) {
				const itApplicationId = action.itApplicationId;
				const itProcessId = action.target.id;

				const itApplication = {
					...state.itApplications.byId[itApplicationId],
					itProcesses: state.itApplications.byId[itApplicationId].itProcesses?.filter((id) => Number(id) !== Number(itProcessId))
				};
				const itProcess = {
					...state.itProcesses.byId[itProcessId],
					itApplications: state.itProcesses.byId[itProcessId].itApplications?.filter((id) => Number(id) !== Number(itApplicationId)),
					children: state.itProcesses.byId[itProcessId].children?.filter((child) => child.entityUId !== itApplicationId)
				};

				let result = {
					...state,
					itApplications: {
						...state.itApplications,
						byId: {
							...state.itApplications.byId,
							[itApplicationId]: itApplication
						}
					},
					itProcesses: {
						...state.itProcesses,
						byId: {
							...state.itProcesses.byId,
							[itProcessId]: itProcess
						}
					}
				};

				return result;
			}

			return state;
		}

		case DELETE_ITPROCESS: {
			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, action.itProcessId, entities.ItProcess)
			};

			if (Array.isArray(result.metadata?.allItProcesses)) {
				result.metadata.allItProcesses = result.metadata.allItProcesses.filter((id) => id !== action.itProcessId);
			}

			result.itApplications = deleteRelationship(result.itApplications, 'itProcesses', action.itProcessId);

			result.itProcesses = normalizedDelete(result.itProcesses, action.itProcessId);

			return result;
		}

		case DELETE_ITCONTROL: {
			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, action.itControlId, entities.ItControl)
			};

			result.metadata = deleteMetadata(state.metadata, action.itControlId, entities.ItProcess, 'unrelatedItControls');

			// Note: ItControls dont have child relationships with other entities. That's why there aren't any calls to deleteRelationship()

			result.itControls = normalizedDelete(result.itControls, action.itControlId);

			return result;
		}

		case DELETE_ITRISK: {
			if (action.error) {
				return state;
			}
			const {itRiskId: deletedItRiskId} = action;

			const deletedItRisk = state.itRisks?.byId?.[deletedItRiskId];
			const itProcess = deletedItRisk && state.itProcesses?.byId?.[deletedItRisk.itProcessId];

			if (!deletedItRisk || !itProcess) {
				return state;
			}

			const itProcessId = itProcess.id;

			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, deletedItRiskId, entities.ItRisk)
			};

			result.itProcesses = deleteRelationship(result.itProcesses, 'itRisks', deletedItRiskId);
			const updatedItControlIds = result.itProcesses.byId[itProcessId].itControls?.filter((itControlId) =>
				result.itProcesses.byId[itProcessId].itRisks?.some((itRiskId) => result.itRisks.byId[itRiskId].itControls?.includes(itControlId))
			);

			result.itProcesses.byId[itProcessId] = {...result.itProcesses.byId[itProcessId], itControls: updatedItControlIds};

			result.itRisks = normalizedDelete(result.itRisks, deletedItRiskId);

			return result;
		}

		case DELETE_RISK: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				const riskId = action.riskId;

				const newState = {
					...state
				};

				newState.risks = normalizedDelete(newState.risks, riskId);

				return newState;
			}
			return state;
		}

		case GET_ENGAGEMENT_ALL_ITCONTROLS:
		case GET_ALL_ITCONTROLS: {
			if (action && action.response) {
				updatedState = {
					...normalizeItControls(action.response, state, action.replace)
				};

				// Update metadata for a body:
				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response?.data,
							action.bodyId,
							action.entityId,
							action.response?.page,
							action.response?.pages,
							action.response?.totalEntityCount,
							action.clientFilters,
							action.metadataKey
						)
					};
				}

				return updatedState;
			} else {
				return state;
			}
		}

		case GET_ITCONTROL_BY_ID: {
			if (action && action.response) {
				// Keep relatedITApplications as full objects
				const relatedITApps = action.response.relatedITApplications || [];

				const updatedItControl = {
					...action.response,
					relatedITApplications: relatedITApps,
					entityName: action.response.itControlName
				};

				// Update only the specific IT control in byId without affecting others
				const updatedItControlsById = {
					...state.itControls?.byId,
					[action.response.id]: updatedItControl
				};

				// Ensure the ID is in allIds if it's not already there
				const currentAllIds = state.itControls?.allIds || [];
				const updatedAllIds = currentAllIds.includes(action.response.id) ? currentAllIds : [...currentAllIds, action.response.id];

				return {
					...state,
					itControls: {
						...state.itControls,
						byId: updatedItControlsById,
						allIds: updatedAllIds
					}
				};
			} else {
				return state;
			}
		}

		case RELATE_ITRISK_ITCONTROL: {
			if (action && action.response) {
				const {itRiskId, itControlId} = action.response;

				const itRisk = {...state.itRisks.byId[itRiskId]};
				if (!itRisk.itControls) {
					itRisk.itControls = [itControlId];
				} else if (!itRisk.itControls.includes(itControlId)) {
					itRisk.itControls = itRisk.itControls.concat(itControlId);
				}

				// Add the new ITControl to the itProcesses related to the itRisk
				const itProcessesRelatedToItRisk = getRelatedEntities(state.itProcesses.byId, 'itRisks', itRiskId);

				if (itProcessesRelatedToItRisk && itProcessesRelatedToItRisk.length > 0) {
					itProcessesRelatedToItRisk.forEach((itProcess) => {
						if (itProcess.itControls && !itProcess.itControls.includes(itControlId)) {
							itProcess.itControls = itProcess.itControls.concat(itControlId);
						}
					});
				}

				updatedState = {
					...state,
					itRisks: normalize([itRisk], undefined, state.itRisks, truthyWinsMergeStrategy),
					itProcesses: normalize(itProcessesRelatedToItRisk, undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case UNRELATE_ITRISK_ITCONTROL: {
			if (!action.error) {
				const {itRiskId, itControlId} = action;
				const itRisksById = state.itRisks.byId;

				const itRisk = {...itRisksById[itRiskId]};
				if (itRisk.itControls && itRisk.itControls.includes(itControlId)) {
					itRisk.itControls = itRisk.itControls.filter((id) => id !== itControlId);
				}

				// Remove the ITControl to the itProcesses related to the itRisk
				const itProcessesRelatedToItRisk = getRelatedEntities(state.itProcesses.byId, 'itRisks', itRiskId);

				if (itProcessesRelatedToItRisk && itProcessesRelatedToItRisk.length > 0) {
					itProcessesRelatedToItRisk.forEach((itProcess) => {
						// No other itRisk is related to the itControl being removed
						if (
							!itProcess.itRisks.some(
								(_itRiskId) => _itRiskId !== itRiskId && itRisksById[_itRiskId].itControls && itRisksById[_itRiskId].itControls.includes(itControlId)
							)
						) {
							// The itProcess is related to the itControlId
							if (itProcess.itControls.includes(itControlId)) {
								itProcess.itControls = itProcess.itControls.filter((id) => id !== itControlId);
							}
						}
					});
				}

				updatedState = {
					...state,
					itRisks: normalize([itRisk], undefined, state.itRisks, truthyWinsMergeStrategy),
					itProcesses: normalize(itProcessesRelatedToItRisk, undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case GET_ALL_TASKS: {
			if (action && action.response && action.response?.taskGroups && action.response?.taskGroups?.length > 0) {
				const tasks = action.response.taskGroups[0].tasks;
				const relatedTasksCollection = tasks.map((t) => {
					const taskInStore = {...state.relatedTasks.byId[t.id]};
					return taskInStore
						? {
								...populateRelevantTaskAttributes(t),
								itProcessId: taskInStore.itProcessId,
								itProcessTaskId: taskInStore.itProcessTaskId
							}
						: {
								...populateRelevantTaskAttributes(t),
								itProcessId: null,
								itProcessTaskId: null
							};
				});
				const relatedTasks = normalize(relatedTasksCollection, undefined, undefined, truthyWinsMergeStrategy);
				return {
					...state,
					relatedTasks
				};
			} else {
				return state;
			}
		}

		case ADD_RELATED_TASK: {
			if (action.taskAttributes) {
				const task = mapTaskAttributes(action.taskAttributes);
				const byIdObject = {
					...state.relatedTasks?.byId,
					[action.taskAttributes.taskId]: task
				};

				const updatedAllIds = cloneDeep(state.relatedTasks.allIds);
				updatedAllIds.push(action.taskAttributes.taskId);

				return {
					...state,
					relatedTasks: {
						...state.relatedTasks,
						byId: byIdObject,
						allIds: updatedAllIds
					}
				};
			}

			return state;
		}

		case GET_RISKS_FACTORS: {
			if (action.response && !action.error) {
				let replace = action.bodyId ? true : false;
				updatedState = normalizeRiskFactors(action.response, state, replace);
				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response,
							action.bodyId,
							action.entityId,
							action.response.page,
							action.response.pages,
							action.response.totalEntityCount,
							action.clientFilters
						)
					};
				}

				return {
					...state,
					...updatedState
				};
			} else {
				return state;
			}
		}

		case UPDATE_RISK_FACTOR_RELATION: {
			if (action.response && !action.error) {
				const riskFactor = {
					...action.response,
					riskId: action.response.riskId || null,
					rationale: action.response.rationale || null
				};

				return {
					...state,
					riskFactors: normalize([riskFactor], undefined, state.riskFactors)
				};
			} else {
				return state;
			}
		}

		case CREATE_RISK: {
			if (action.response && !action.error) {
				return {
					...state,
					risks: normalize([action.response], undefined, state.risks, truthyWinsMergeStrategy)
				};
			} else {
				return state;
			}
		}

		case UPDATE_RISK: {
			if (action.response && !action.error) {
				const _updatedRisk = {
					...state.risks,
					byId: {
						...state.risks.byId,
						[action.response.id]: {
							...state.risks.byId[action.response.id],
							riskName: action.response.riskName,
							entityName: action.response.riskName
						}
					}
				};

				return {
					...state,
					risks: _updatedRisk
				};
			}

			return state;
		}

		case PUT_WCGW: {
			if (action.response) {
				const _updatedWcgw = {
					...state.wcgws,
					byId: {
						...state.wcgws.byId,
						[action.response.id]: {
							...state.wcgws.byId[action.response.id],
							wcgwName: action.response.wcgwName,
							entityName: action.response.wcgwName
						}
					}
				};

				return {
					...state,
					wcgws: _updatedWcgw
				};
			}

			return state;
		}

		case GET_RISK_TYPES: {
			if (action.response && action.response.data) {
				updatedState = normalizeRiskTypes(action.response.data, state.riskTypes);

				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response.data,
							action.bodyId,
							action.entityId,
							action.response.page,
							action.response.pages,
							action.response.totalEntityCount,
							action.clientFilters
						)
					};
				}

				return {
					...state,
					...updatedState
				};
			} else {
				return state;
			}
		}

		case GET_RISKS: {
			if (action.response && !action.error) {
				updatedState = normalizeRisks(action.response.data, state);

				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response.data,
							action.bodyId,
							action.entityId,
							action.response.page,
							action.response.pages,
							action.response.totalEntityCount,
							action.clientFilters
						)
					};
				}

				return {
					...state,
					...updatedState
				};
			}
			return state;
		}

		case RELATE_TASK_ITPROCESS: {
			if (action.response && !action.error) {
				const {taskId, itProcessId} = action.response;
				const itProcess = {...state.itProcesses.byId[itProcessId]};
				if (itProcess.relatedTasks && !itProcess.relatedTasks.includes(taskId)) {
					itProcess.relatedTasks = itProcess.relatedTasks.concat(taskId);
				} else {
					itProcess.relatedTasks = [taskId];
				}

				updatedState = {
					...state,
					itProcesses: normalize([itProcess], undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case UNRELATE_TASK_ITPROCESS: {
			if (action && !action.error) {
				const {taskId, itProcessId} = action;
				const itProcess = {...state.itProcesses.byId[itProcessId]};
				if (itProcess.relatedTasks && itProcess.relatedTasks.includes(taskId)) {
					itProcess.relatedTasks = itProcess.relatedTasks.filter((realtedTaskId) => realtedTaskId !== taskId);
				}

				updatedState = {
					...state,
					itProcesses: normalize([itProcess], undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case CREATE_ITAPPLICATION_ITPROCESS_RELATIONSHIP: {
			if (action.response && !action.error) {
				const {itApplicationId, itProcessId} = action.response;

				const itApplication = {
					...state?.itApplications?.byId[itApplicationId],
					itProcesses: sortBy(
						(state?.itApplications?.byId[itApplicationId]?.itProcesses || []).concat(itProcessId),
						(id) => state?.itProcesses?.byId[id]?.itProcessName
					)
				};
				const itProcess = {
					...state?.itProcesses?.byId[itProcessId],
					itApplications: sortBy(
						(state?.itProcesses?.byId[itProcessId]?.itApplications || []).concat(itApplicationId),
						(id) => state?.itApplications?.byId[id]?.itApplicationName
					)
				};

				updatedState = {
					...state,
					itApplications: {
						...state.itApplications,
						byId: {
							...state.itApplications.byId,
							[itApplicationId]: itApplication
						}
					},
					itProcesses: {
						...state.itProcesses,
						byId: {
							...state.itProcesses.byId,
							[itProcessId]: itProcess
						}
					}
				};

				return updatedState;
			}
			return state;
		}

		case CREATE_ITPROCESS_SUPPORTING_ITAPPLICATION_RELATIONSHIP: {
			if (action.response && !action.error) {
				const {supportingITApplicationId, itProcessId} = action.response;
				const itApplication = {
					...state.itApplications.byId[supportingITApplicationId],
					itProcesses: sortBy(
						(state.itApplications.byId[supportingITApplicationId].itProcesses || []).concat(itProcessId),
						(id) => state.itProcesses.byId[id].itProcessName
					)
				};
				const itProcess = {
					...state.itProcesses.byId[itProcessId],
					itApplications: sortBy(
						(state.itProcesses.byId[itProcessId].itApplications || []).concat(supportingITApplicationId),
						(id) => state.itApplications.byId[id].itApplicationName
					)
				};
				updatedState = {
					...state,
					itApplications: {
						...state.itApplications,
						byId: {
							...state.itApplications.byId,
							[supportingITApplicationId]: itApplication
						}
					},
					itProcesses: {
						...state.itProcesses,
						byId: {
							...state.itProcesses.byId,
							[itProcessId]: itProcess
						}
					}
				};
			}
			return state;
		}

		case DELETE_ITPROCESS_SUPPORTING_ITAPPLICATION_RELATIONSHIP: {
			if (!action.error && state.itApplications && state.itProcesses) {
				const supportingITApplicationId = action.target.id;
				const itProcessId = action.itProcessId;

				const itApplication = {
					...state.itApplications.byId[supportingITApplicationId],
					itProcesses: state.itApplications.byId[supportingITApplicationId].itProcesses?.filter((id) => Number(id) !== Number(itProcessId))
				};
				const itProcess = {
					...state.itProcesses.byId[itProcessId],
					itApplications: state.itProcesses.byId[itProcessId].itApplications?.filter((id) => Number(id) !== Number(supportingITApplicationId)),
					children: state.itProcesses.byId[itProcessId].children?.filter((child) => child.entityUId !== itApplicationId)
				};

				let result = {
					...state,
					itApplications: {
						...state.itApplications,
						byId: {
							...state.itApplications.byId,
							[supportingITApplicationId]: itApplication
						}
					},
					itProcesses: {
						...state.itProcesses,
						byId: {
							...state.itProcesses.byId,
							[itProcessId]: itProcess
						}
					}
				};

				return result;
			}

			return state;
		}

		case IT_PROCESS_SELECTED: {
			return selectEntity(state, action, 'itProcesses', 'itApplications');
		}

		case IT_APPLICATION_SELECTED: {
			return selectEntity(state, action, 'itApplications', 'itProcesses');
		}

		case CREATE_ITPROCESS: {
			if (!state.hasOwnProperty('itProcesses') || action.error) {
				return state;
			}

			const response = {
				...action.response,
				itApplications: action.response?.itApplications || []
			};

			updatedState = {
				itProcesses: normalizedCreate(state.itProcesses, response)
			};

			if (response.relatedTasks && state.hasOwnProperty('relatedTasks')) {
				const relatedTasks = cloneDeep(state.relatedTasks);
				response.relatedTasks.forEach((taskId) => {
					if (relatedTasks.byId.hasOwnProperty(taskId)) {
						const relatedTask = relatedTasks.byId[taskId];
						if (Array.isArray(relatedTask.itProcessId)) {
							relatedTask.itProcessId.push(response.id);
						} else {
							relatedTask.itProcessId = [response.id];
						}
					}
				});

				updatedState.relatedTasks = relatedTasks;
			}

			// Merge current store state with updated state:
			updatedState = {
				...state,
				...updatedState
			};

			// Update metadata slices that show ITProcesses (entityId == ItProcess)
			updatedState = {
				...updatedState,
				metadata: updateMetadata(updatedState.metadata, response.id, entities.ItProcess)
			};

			return updatedState;
		}

		case UPDATE_ITPROCESS: {
			if (!state.hasOwnProperty('itProcesses') || action.error) {
				return state;
			}

			if (!state.itProcesses?.allIds?.includes(action.response.id)) {
				return state;
			}

			const _updatedItProcess = {
				...state.itProcesses,
				byId: {
					...state.itProcesses.byId,
					[action.response.id]: {
						...state.itProcesses.byId[action.response.id],
						itProcessName: action.response.itProcessName,
						entityName: action.response.itProcessName
					}
				}
			};

			return {
				...state,
				itProcesses: _updatedItProcess
			};
		}

		case CREATE_ITRISK: {
			if (!state.hasOwnProperty('itProcesses') || action.error) {
				return state;
			}

			const itProcessId = action.meta.api.data.itprocessId || action.meta.api.data.itProcessId;
			if (!state.itProcesses?.allIds?.includes(itProcessId)) {
				return state;
			}

			const itProcess = state.itProcesses.byId[itProcessId];

			const itRiskArray = Array.isArray(itProcess.itRisks) ? [...itProcess.itRisks, action.response.id] : [action.response.id];

			const _itProcesses = {
				...state.itProcesses,
				byId: {
					...state.itProcesses.byId,
					[itProcessId]: {
						...itProcess,
						itRisks: itRiskArray
					}
				}
			};

			const _itRisks = state.hasOwnProperty('itRisks')
				? normalize([{...action.response, itProcessId}], undefined, state.itRisks, concatMergeStrategy)
				: normalize([{...action.response, itProcessId}]);

			return {
				...state,
				itProcesses: _itProcesses,
				itRisks: _itRisks
			};
		}

		case CREATE_ITAPPLICATION_SO: {
			if (!state.hasOwnProperty('itApplications') || action.error) {
				return state;
			}

			const response = {
				...action.response,
				itProcesses: action.response.itProcesses || []
			};

			updatedState = {
				itApplications: normalizedCreate(state.itApplications, response)
			};

			if (response.scots && state.hasOwnProperty('scots')) {
				const scots = cloneDeep(state.scots);
				response.scots.forEach((scotId) => {
					if (scots.byId.hasOwnProperty(scotId)) {
						const scot = scots.byId[scotId];
						if (Array.isArray(scot.itApplications)) {
							scot.itApplications.push(response.id);
						} else {
							scot.itApplications = [response.id];
						}
					}
				});

				updatedState.scots = scots;
			}

			if (response.controls && state.hasOwnProperty('controls')) {
				const controls = cloneDeep(state.controls);
				response.controls.forEach((controlId) => {
					if (controls.byId.hasOwnProperty(controlId)) {
						const control = controls.byId[controlId];
						if (Array.isArray(control.itApplications)) {
							control.itApplications.push(response.id);
						} else {
							control.itApplications = [response.id];
						}
					}
				});

				updatedState.controls = controls;
			}

			// Merge current store state with updated state:
			updatedState = {
				...state,
				...updatedState
			};

			// Update metadata slices that show ITApplications (entityId == ItApp)
			updatedState = {
				...updatedState,
				metadata: updateMetadata(updatedState.metadata, response.id, entities.ItSoApplication)
			};

			return updatedState;
		}

		case CREATE_IT_SO: {
			if (!state.hasOwnProperty('itsoApplications') || action.error) {
				return state;
			}

			const response = {
				...action.response,
				itProcesses: action.response.itProcesses || []
			};

			updatedState = {
				itsoApplications: normalizedCreate(state.itsoApplications, response)
			};

			if (response.scots && state.hasOwnProperty('scots')) {
				const scots = cloneDeep(state.scots);
				response.scots.forEach((scotId) => {
					if (scots.byId.hasOwnProperty(scotId)) {
						const scot = scots.byId[scotId];
						if (Array.isArray(scot.itApplications)) {
							scot.itApplications.push(response.id);
						} else {
							scot.itApplications = [response.id];
						}
					}
				});

				updatedState.scots = scots;
			}

			if (response.controls && state.hasOwnProperty('controls')) {
				const controls = cloneDeep(state.controls);
				response.controls.forEach((controlId) => {
					if (controls.byId.hasOwnProperty(controlId)) {
						const control = controls.byId[controlId];
						if (Array.isArray(control.itApplications)) {
							control.itApplications.push(response.id);
						} else {
							control.itApplications = [response.id];
						}
					}
				});

				updatedState.controls = controls;
			}

			// Merge current store state with updated state:
			updatedState = {
				...state,
				...updatedState
			};

			// Update metadata slices that show ITApplications (entityId == ItApp)
			updatedState = {
				...updatedState,
				metadata: updateMetadata(updatedState.metadata, response.id, entities.ItSoApplication)
			};

			return updatedState;
		}

		case UPDATE_ITRISK: {
			if (!state.hasOwnProperty('itRisks') || action.error) {
				return state;
			}

			if (!state.itRisks?.allIds?.includes(action.response.id)) {
				return state;
			}

			const itProcessId = action.meta.api.data.itprocessId;
			const _itRisk = state.itRisks.byId[action.response.id];

			let _updatedItRisks = {
				...state.itRisks,
				byId: {
					...state.itRisks.byId,
					[action.response.id]: {
						..._itRisk,
						...action.response,
						entityName: action.response.itRiskName
					}
				}
			};

			if (action.response.hasNoITGC && state.itControls && Array.isArray(_itRisk.itControls)) {
				const itProcess = state.itProcesses.byId[itProcessId];

				const relatedITControls = state.itControls.allIds.filter((id) => _itRisk.itControls.includes(id)).map((id) => state.itControls.byId[id]);

				const itGcs = relatedITControls.filter((ic) => ic.itApproachTypeId === itControlApproachType.controls).map((ic) => ic.id);

				const _itProcesses = {
					...state.itProcesses,
					byId: {
						...state.itProcesses.byId,
						[itProcessId]: {
							...itProcess,
							itControls: Array.isArray(itProcess.itControls) ? itProcess.itControls.filter((id) => !itGcs.includes(id)) : itProcess.itControls
						}
					}
				};

				_updatedItRisks = {
					...state.itRisks,
					byId: {
						...state.itRisks.byId,
						[action.response.id]: {
							..._itRisk,
							...action.response,
							itControls: _itRisk.itControls.filter((id) => !itGcs.includes(id))
						}
					}
				};

				return {
					...state,
					itProcesses: _itProcesses,
					itRisks: _updatedItRisks
				};
			}

			return {
				...state,
				itRisks: _updatedItRisks
			};
		}

		case CREATE_ITCONTROL: {
			const itRiskId = action.meta.api.data.itRiskId;
			if (!state.itRisks?.allIds?.includes(itRiskId) || action.error) {
				return state;
			}

			const itRisk = state.itRisks.byId[itRiskId];
			if (!itRisk) {
				return state;
			}
			const itProcessId = action.itProcessId;

			const itControlArray = Array.isArray(itRisk.itControls) ? [...itRisk.itControls, action.response.id] : [action.response.id];

			const _itRisks = {
				...state.itRisks,
				byId: {
					...state.itRisks.byId,
					[itRiskId]: {
						...itRisk,
						itControls: itControlArray
					}
				}
			};

			const newControl = {
				...action.response,
				...{itProcessId, itRiskId}
			};

			const _itControls = normalize([newControl], undefined, state.itControls, concatMergeStrategy);

			const itProcess = state.itProcesses.byId[itRisk.itProcessId];
			if (!itProcess) {
				return state; // Early exit if itProcess doesn't exist
			}
			const itControlsArray = Array.isArray(itProcess.itControls) ? [...itProcess.itControls, newControl.id] : [newControl.id];

			const _itProcesses = {
				...state.itProcesses,
				byId: {
					...state.itProcesses.byId,
					[itRisk.itProcessId]: {
						...itProcess,
						itControls: itControlsArray
					}
				}
			};

			return {
				...state,
				itProcesses: _itProcesses,
				itRisks: _itRisks,
				itControls: _itControls
			};
		}

		case UPDATE_ITCONTROL: {
			if (!state.hasOwnProperty('itControls') || action.error) {
				return state;
			}

			if (!state.itControls?.allIds?.includes(action.response.id)) {
				return state;
			}

			const itRiskId = action.meta.api.data.itRiskId;
			const itProcessId = action.itProcessId;

			const itControlPayload = {
				...action.response,
				itProcessId: itProcessId,
				itRiskId: itRiskId,
				entityName: action.response.itControlName
			};

			const _updatedItControls = normalizedUpdate(itControlPayload.id, itControlPayload, state.itControls);

			return {
				...state,
				itControls: _updatedItControls
			};
		}

		case UPDATE_SCOT: {
			if (!state.hasOwnProperty('scots') || action.error) {
				return state;
			}

			const payload = action.meta.api.data;

			if (!state.scots?.allIds?.includes(payload.id)) {
				return state;
			}

			const scotId = payload.id;
			const scot = state.scots.byId[scotId];

			// Merge the itApplications and itSOs into one array
			let scotItApplications = [];
			scotItApplications = scotItApplications.concat(payload.itApplications || [], payload.itsOs || payload.itSOs || []);

			const itApplications = state.itApplications;
			let updatedItApplications = [];

			// Add / remove edited scot from itApplications in the store
			for (const id of itApplications.allIds) {
				// Get the itApp details
				let itAppDetails = {
					id: id,
					scots: itApplications.byId[id].scots ? [...itApplications.byId[id].scots] : []
				};

				if (scotItApplications.includes(id)) {
					// Current itApp is in the response -> Add it to scots collection
					if (!itAppDetails.scots.includes(scotId)) {
						itAppDetails.scots.push(scotId);
					}
				} else {
					// Current itAp is not in the response (got removed) -> Remove it from scots collection
					if (itAppDetails.scots.includes(scotId)) {
						itAppDetails.scots = itAppDetails.scots.filter((_scotId) => _scotId !== scotId);
					} else {
						// No changes made. Should not update the store.
						itAppDetails = null;
					}
				}

				if (itAppDetails) {
					updatedItApplications.push(itAppDetails);
				}
			}

			let newAllITAppSCOTsSlice;

			//Add/Remove Scot from allITAppSCOTs slice if the scot's hasItApplication flag changes.
			if (state.metadata.allITAppSCOTs !== undefined && payload.hasNoITApplication !== scot.hasNoITApplication) {
				newAllITAppSCOTsSlice = [...state.metadata.allITAppSCOTs];

				if (!payload.hasNoITApplication) {
					//Add scot to AllITAppSCOTs slice so the scot shows on the edit ItApp modal's relate scot combo.
					newAllITAppSCOTsSlice.push(scotId);
				} else {
					//Remove scot from AllITAppSCOTs slice so the scot dissapears from the edit ItApp modal's relate scot combo.
					let scotIndex = newAllITAppSCOTsSlice.indexOf(scotId);
					newAllITAppSCOTsSlice.splice(scotIndex, 1);
				}
			}

			const _scots = {
				...state.scots,
				byId: {
					...state.scots.byId,
					[payload.id]: {
						...scot,
						scotName: payload.scotName,
						strategyTypeId: payload.strategyTypeId,
						hasNoITApplication: payload.hasNoITApplication,
						scotTypes: payload.scotTypes,
						itApplications: scotItApplications,
						entityName: payload.scotName
					}
				}
			};

			return {
				...state,
				itApplications: normalize(updatedItApplications, undefined, state.itApplications, truthyWinsMergeStrategy),
				scots: _scots,
				metadata: {
					...state.metadata,
					allITAppSCOTs: newAllITAppSCOTsSlice || state.metadata.allITAppSCOTs
				}
			};
		}

		case UPDATE_CONTROL: {
			if (!state.hasOwnProperty('controls') || action.error) {
				return state;
			}

			const payload = action.meta.api.data;
			const {response} = action;

			if (!state.controls?.allIds?.includes(payload.id)) {
				return state;
			}

			const control = state.controls.byId[payload.id];

			const controlItApplications = payload.ITApplicationOrSOIds;

			const itApplications = cloneDeep(state.itApplications);

			for (const id of itApplications.allIds) {
				const itApp = itApplications.byId[id];
				if (controlItApplications && controlItApplications.includes(id) && !itApp?.controls?.includes(payload.id)) {
					if (Array.isArray(itApp.controls)) {
						itApp.controls.push(payload.id);
					} else {
						itApp.controls = [payload.id];
					}
				} else if (controlItApplications && !controlItApplications.includes(id) && itApp?.controls?.includes(payload.id)) {
					itApp.controls = itApp.controls.filter((controlId) => controlId !== payload.id);
				}
			}

			const _control = {
				...state.controls,
				byId: {
					...state.controls.byId,
					[payload.id]: {
						...control,
						controlName: response.controlName,
						controlTypeId: response.controlTypeId,
						controlDesignEffectivenessTypeId: response.controlDesignEffectivenessTypeId,
						controlFrequencyTypeId: response.controlFrequencyTypeId,
						hasControlTesting: response.hasControlTesting,
						itApplications: controlItApplications,
						isEffective: response.isEffective,
						isLowerRisk: response.isLowerRisk,
						isIPEManuallyTested: response.isIPEManuallyTested,
						entityName: response.controlName
					}
				}
			};

			return {
				...state,
				itApplications,
				controls: _control
			};
		}

		case UPDATE_ITAPPLICATION: {
			if (!state.hasOwnProperty('itApplications') || action.error) {
				return state;
			}

			const response = action.response;

			if (!state.itApplications?.allIds?.includes(response.id)) {
				return state;
			}

			const itApplication = state.itApplications.byId[response.id];

			const itApplications = {
				...state.itApplications,
				byId: {
					...state.itApplications.byId,
					[response.id]: {
						...itApplication,
						itApplicationName: response.itApplicationName,
						engagementId: response.engagementId,
						isServiceOrganization: response.isServiceOrganization,
						scots: response.scots,
						controls: response.controls,
						entityName: response.itApplicationName
					}
				}
			};

			const itApplicationScots = response.scots;
			const scots = cloneDeep(state.scots);

			for (const id of scots.allIds) {
				const scot = scots.byId[id];
				if (itApplicationScots.includes(id) && !scot?.itApplications?.includes(response.id)) {
					if (Array.isArray(scot.itApplications)) {
						scot.itApplications.push(response.id);
					} else {
						scot.itApplications = [response.id];
					}
				} else if (!itApplicationScots.includes(id) && scot?.itApplications?.includes(response.id)) {
					scot.itApplications = scot.itApplications.filter((id) => id !== response.id);
				}
			}

			const itApplicationControls = response.controls;
			const controls = cloneDeep(state.controls);

			for (const id of controls.allIds) {
				const control = controls.byId[id];
				if (itApplicationControls.includes(id) && !control?.itApplications?.includes(response.id)) {
					if (Array.isArray(control.itApplications)) {
						control.itApplications.push(response.id);
					} else {
						control.itApplications = [response.id];
					}
				} else if (!itApplicationControls.includes(id) && control?.itApplications?.includes(response.id)) {
					control.itApplications = control.itApplications.filter((id) => id !== response.id);
				}
			}

			return {
				...state,
				itApplications,
				scots,
				controls
			};
		}

		case UPDATE_IT_SO: {
			if (!state.hasOwnProperty('itsoApplications') || action.error) {
				return state;
			}

			const response = action.response;

			if (!state.itsoApplications?.allIds?.includes(response.id)) {
				return state;
			}

			// Use the normalization function for consistent update
			const normalizedState = normalizeITSOApplications([response], state);

			return {
				...state,
				...normalizedState
			};
		}

		case GET_ALL_ITPROCESSES_WITHOUT_PAGINATION: {
			return {
				...normalizeItProcesses(action.response.data, state),
				metadata: getMetadata(
					state,
					action.response.data,
					action.bodyId,
					action.entityId,
					action.response.page,
					action.response.pages,
					action.response.totalEntityCount,
					action.clientFilters
				)
			};

			// const flattenedITRisks = action.response.data.flatMap((itProcess) => itProcess.itRisks);
			// const itRisks = normalize(flattenedITRisks, undefined);

			// const itProcesses = normalize(
			// 	action.response.data.map((itProcess) => {
			// 		return {
			// 			...itProcess,
			// 			itRisks: itProcess.itRisks?.map((itRisk) => itRisk.id)|| [],
			// 			itControls: itProcess.itControls?.map((itControl) => itControl.id) || []
			// 		};
			// 	}),
			// 	undefined,
			// 	state.itProcesses,
			// 	truthyWinsMergeStrategy
			// );

			// const metadata = {
			// 	...state.metadata,
			// 	allItProcesses: [...itProcesses.allIds]
			// };

			// return {
			// 	...state,
			// 	metadata,
			// 	itRisks,
			// 	itProcesses
			// };
		}

		case GET_FORM_BODIES_BY_SECTIONID: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			//Controls are the only entities that do not apply truthyWinsMergeStrategy but a custom concatMergeStrategy.
			//We need to make sure it's always cleaned up when navigating between sections to avoid concurrency scenarios.
			state.controls = {
				...normalize()
			};

			const bodyRelatedObjects = action.response.flatMap((body) => body.bodyRelatedObjects);

			let updateState;

			const entityTypesId = [];

			bodyRelatedObjects.forEach((bro) => {
				if (!entityTypesId.includes(bro.entityId)) {
					entityTypesId.push(bro.entityId);
				}
			});

			for (let i = 0; i < entityTypesId.length; i++) {
				const entityTypeId = entityTypesId[i];
				const entities = bodyRelatedObjects.filter((entity) => entity.entityId === entityTypeId);

				//Bodies type 8 and 10 both use Controls as root entity but have different children entities (scot & risk),
				//We need to do a custom normalize for both parent and children.
				const childrenNormalize = getChildrenNormalize(entityTypeId);
				const mergeStrategy = getMergeStrategy(entityTypeId);
				updateState = normalizeEntities(entities, state, mergeStrategy, childrenNormalize);
			}

			let metadata = state?.metadata || {};
			for (const body of action.response.filter((b) => b.bodyRelatedObjects?.length > 0)) {
				// First level's entityId
				const mainEntityId = body.bodyRelatedObjects[0].entityId;

				metadata = {
					...metadata,
					...getMetadata(
						updateState,
						body.bodyRelatedObjects,
						body.id,
						mainEntityId,
						undefined,
						undefined,
						body.bodyRelatedObjects.length,
						undefined,
						undefined,
						(item) => ({entityId: item.entityId, entityUId: item.entityUId})
					)
				};
			}

			return {
				...state,
				...updateState,
				metadata
			};
		}

		case UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE: {
			const response = action.response;
			const sliceName = specialBodiesSlices[response.entityId];

			return {
				...state,
				[sliceName]: {
					...state[sliceName],
					byId: {
						...state[sliceName].byId,
						[response.entityUId]: {...state[sliceName].byId[response.entityUId], ...response}
					}
				}
			};
		}

		case GET_CONTROL_BY_ID: {
			if (!state.hasOwnProperty('controls') || action.error) {
				return state;
			}

			return {
				state,
				...normalizeControls(action.response, state)
			};
		}
		case GET_ALL_CRA_ACCOUNTS:
			if (action.response && action.response.data) {
				const accountList = normalize(action.response.data); // just normalize the data directly

				accountList.pages = action.response.pages;
				accountList.page = action.response?.page;
				accountList.totalEntityCount = action.response.totalEntityCount;

				return {
					...state,
					craAccounts: accountList
				};
			}
			return state;

		case GET_CRA_ORPHANED_RISKS_COUNT: {
			return {
				...state,
				orphanedRisks: action.response
			};
		}

		case GET_TECHNOLOGY_DETAILS:
		case GET_ALL_IT_APPS: {
			return {
				...state,
				itApplications: normalize(action.response?.data)
			};
		}

		case GET_ALL_IT_APPS_SO: {
			return {
				...state,
				itsoApplications: normalize(action.response?.data)
			};
		}

		case DELETE_IT_APPS_BY_ID_SO: {
			if (isApiResponseOk(action) || action?.error?.response.status === HttpStatusCodes.NotFound) {
				return {
					...state,
					itsoApplications: deleteItApplicationFromState(state.itsoApplications, action.itApplicationId)
				};
			}
			return state;
		}

		case DELETE_IT_APPS_BY_ID: {
			if (isApiResponseOk(action) || action?.error?.response.status === HttpStatusCodes.NotFound) {
				return {
					...state,
					itApplications: deleteItApplicationFromState(state.itApplications, action.itApplicationId)
				};
			}
			return state;
		}

		case UPDATE_MANAGE_ACCOUNT:
			if (action.response && !action.error && !action.isManageAccounts) {
				const updatedAccount = action.response;
				let newState = {...state};
				const updatedState = {
					...newState,
					craAccounts: normalizedUpdate(updatedAccount.id, updatedAccount, newState.craAccounts)
				};
				return updatedState;
			}
			return state;

		case UPDATE_ASSERTION_IR_CR:
			if (action.response) {
				let newState = _.cloneDeep(state);
				let slice = newState?.craAccounts || {};
				return {
					...newState,
					craAccounts: {
						...slice,
						byId: {
							...slice?.byId,
							[action.response.accountID]: {
								...slice?.byId[action.response.accountID],
								assertions: slice?.byId[action.response.accountID]?.assertions?.map((assertion) => {
									if (assertion.id === action.response.id) {
										// Only update IRA/CRA/CRAValue - do NOT update risks
										// Risks with isHigherRisk values are managed separately via updateRiskColumn
										return {
											...assertion,
											controlRiskTypeId: action.response.controlRiskTypeId,
											inherentRiskTypeId: action.response.inherentRiskTypeId,
											craValue: action.response.craValue
										};
									}
									return assertion;
								})
							}
						}
					}
				};
			}
			return state;
		case PATCH_ACCOUNT_RATIONALE:
			if (action.response) {
				let newState = _.cloneDeep(state);
				let slice = newState?.craAccounts || {};
				return {
					...newState,
					craAccounts: {
						...slice,
						byId: {
							...slice?.byId,
							[action.response.id]: {
								...slice?.byId[action.response.id],
								rationale: action.response.rationale
							}
						}
					}
				};
			}
			return state;
		case PATCH_RISK:
			if (state.craAccounts?.byId && action.response) {
				const riskId = action.response.riskId;
				const isHigherRisk = action.response.isHigherRisk;
				if (!riskId || isHigherRisk === undefined) return state;

				const slice = state.craAccounts;
				let hasChanges = false;
				const updatedById = {};

				// Update accounts/assertions that contain the updated risk with the new isHigherRisk value
				// Also update inherentRiskTypeId to HIGHER if any risk has isHigherRisk set to true
				Object.keys(slice.byId).forEach((accountId) => {
					const account = slice.byId[accountId];
					if (!account?.assertions) return;

					let accountChanged = false;
					const updatedAssertions = account.assertions.map((assertion) => {
						if (!assertion.risks?.some((risk) => risk.id === riskId)) {
							return assertion;
						}
						accountChanged = true;

						let hasAnyHigherRisk = false;
						const updatedRisks = assertion.risks.map((risk) => {
							if (risk.id === riskId) {
								if (!risk.isRejected && isHigherRisk) hasAnyHigherRisk = true;
								return {...risk, isHigherRisk, riskIsHigherRisk: isHigherRisk};
							}
							if (!risk.isRejected && (risk.isHigherRisk || risk.riskIsHigherRisk)) {
								hasAnyHigherRisk = true;
							}
							return risk;
						});

						return {
							...assertion,
							risks: updatedRisks,
							inherentRiskTypeId: hasAnyHigherRisk ? inherentRiskTypeId.HIGHER : assertion.inherentRiskTypeId
						};
					});

					if (accountChanged) {
						hasChanges = true;
						updatedById[accountId] = {...account, assertions: updatedAssertions};
					}
				});

				if (!hasChanges) return state;

				return {
					...state,
					craAccounts: {
						...slice,
						byId: {...slice.byId, ...updatedById}
					}
				};
			}
			return state;

		default:
			return state;
	}
}

function getRelatedEntities(entitiesById, navigationPropertyName, entityUId) {
	if (entitiesById && navigationPropertyName && entityUId) {
		return Object.values(entitiesById)
			.filter((entity) => entity[navigationPropertyName] && entity[navigationPropertyName].includes(entityUId))
			.map((entity) => {
				return {...entity};
			});
	}
}

/**
 * Updates the metadata prop accordingly.
 * @param {object} state The current state with the metadata prop in it.
 * @param {Array} data The data being handled.
 * @param {number} bodyId The body's Id.
 * @param {number} entityId The body's main entity's Id.
 * @param {number} page Page number if pagination is available.
 * @param {number} pages Page count if pagination is available.
 * @param {number} totalEntityCount Total entity count (without pagination).
 * @param {object} clientFilters Client-side flters to be applied on the body.
 * @param {string} keyname The key in which the Id collection is being put, defaults to allIds.
 * @param {function} customEntityMapper A custom entity mapper to be used.
 * @returns {object} A new object with the updated metadata.
 */
export function getMetadata(
	state,
	data,
	bodyId,
	entityId,
	page = 1,
	pages = 1,
	totalEntityCount = 0,
	clientFilters = undefined,
	keyname = undefined,
	customEntityMapper
) {
	let entityMapper = customEntityMapper || ((item) => item.id);

	if (!bodyId) {
		return state.metadata;
	}

	const allIds = data?.map((value) => entityMapper(value));

	if (!keyname) {
		return {
			...state.metadata,
			[bodyId]: {
				...state.metadata[bodyId],
				entityId,
				allIds,
				page,
				pages,
				totalEntityCount: totalEntityCount || allIds.length,
				clientFilters,
				filteredIds: null
			}
		};
	} else {
		return {
			...state.metadata,
			[bodyId]: {
				...state.metadata[bodyId],
				[keyname]: allIds
			}
		};
	}
}

function updateMetadata(metadata, newIds, entityId, keyName = ['allIds', 'filteredIds']) {
	if (!metadata || !newIds || entityId === null || entityId === undefined) {
		return metadata;
	}

	const result = {
		...metadata
	};

	if (!Array.isArray(keyName)) {
		keyName = [keyName];
	}
	if (!Array.isArray(newIds)) {
		newIds = [newIds];
	}

	Object.entries(metadata).forEach((entry) => {
		const [bodyId, metadataContent] = entry;
		if (metadataContent?.entityId === entityId) {
			result[bodyId] = {
				...metadata[bodyId]
			};

			keyName.forEach((key) => {
				if (result[bodyId][key]) {
					// Merge array stored in metadata with newValues (results in a unique id list)
					result[bodyId][key] = _.union(result[bodyId][key], newIds);
				}
			});
		}
	});

	return result;
}

/**
 * Removes the deleted entity Id from all other bodies that hold the same entity type.
 * @param {object} metadata The current metadata state.
 * @param {number} id The Id of the entity being deleted in the allIds array.
 * @param {number} entityId The type Id of the entity (uiconstats).
 * @param {string} keyname The key in which the Id of the entity is being deleted, defaults to allIds.
 * @returns {object} A new object with the updated metadata.
 */
function deleteMetadata(metadata, id, entityId, keyname = ['allIds', 'filteredIds']) {
	const result = {
		...metadata
	};

	if (!Array.isArray(keyname)) {
		keyname = [keyname];
	}

	Object.entries(result).forEach((entry) => {
		if (entry[1]?.entityId === entityId) {
			const bodyId = entry[0];

			result[bodyId] = {
				...result[bodyId]
			};

			keyname.forEach((key) => {
				if (result[bodyId][key]) {
					result[bodyId][key] = result[bodyId][key].filter((value) => value !== id);
				}
			});
		}
	});

	return result;
}

/**
 *
 * @param {object} state The current state.
 * @param {object} action The dispatched action.
 * @param {string} origin The entity's slice name, which is being selected.
 * @param {string} destination The entity's slice name, which is being affected by the origin entity.
 * @returns {object} The new state.
 */
function selectEntity(state, action, origin, destination) {
	const selected = !state[origin].byId[action.id].selected;
	const hasAssociation = !state[origin].byId[action.id].hasAssociation;

	const result = {
		...state,
		[origin]: {
			...state[origin],
			byId: Object.fromEntries(
				Object.entries(state[origin].byId).map((entry) => {
					// WARNING: DO NOT use !== here. entry[0] is a string while action.id is a number.
					// eslint-disable-next-line
					if (entry[0] !== action.id) {
						if (entry[1].selected) {
							if (entry[1].hasAssociation) {
								return [entry[0], {...entry[1], selected: false, hasAssociation: false}];
							}
							return [entry[0], {...entry[1], selected: false}];
						} else {
							return entry;
						}
					} else {
						if (state[destination]) {
							const destinationIds = state[origin].byId[action.id][destination];
							if (destinationIds && destinationIds.length > 0) {
								return [entry[0], {...entry[1], selected, hasAssociation}];
							}
						}
						return [entry[0], {...entry[1], selected}];
					}
				})
			)
		}
	};

	if (result[destination]) {
		const destinationIds = result[origin].byId[action.id][destination];

		result[destination] = {
			...result[destination],
			byId: Object.fromEntries(
				Object.entries(state[destination].byId).map((entry) => {
					// WARNING: DO NOT use === here. entry[0] is a string while id is a number.
					// eslint-disable-next-line
					if (destinationIds.some((id) => id === entry[0])) {
						return [entry[0], {...entry[1], selected, hasAssociation}];
					} else {
						if (entry[1].selected) {
							if (entry[1].hasAssociation) {
								return [entry[0], {...entry[1], selected: false, hasAssociation: false}];
							}
							return [entry[0], {...entry[1], selected: false}];
						} else {
							return entry;
						}
					}
				})
			)
		};
	}

	return result;
}

// Given a denormalized list of itRisks and itControls, returns a normalized (nested) version of the data
function buildItRisksForItProcess(itProcess) {
	const normalizedItRisks = [];
	const itProcessItRisks = itProcess?.itRisks;
	const itProcessItControls = itProcess?.itControls;

	if (itProcessItRisks && itProcessItRisks.length > 0 && itProcessItControls) {
		for (const itRisk of itProcessItRisks) {
			itRisk.itProcessName = itProcess.itProcessName;
			itRisk.itControls = itProcessItControls.filter((itCtrl) => itCtrl.itRiskId === itRisk.id);
			normalizedItRisks.push(itRisk);
		}
	}

	return normalizedItRisks;
}

function populateRelevantTaskAttributes(task) {
	return {
		taskName: task.name,
		taskNamePrefix: task.taskNamePrefix,
		taskNameSuffix: task.taskNameSuffix,
		knowledgeTaskTitle: task.knowledgeTaskTitle,
		taskTypeId: task.typeId,
		taskStatusId: task.statusId,
		isEPTask: task.isEPSignoffRequired,
		isEQRTask: task.isEQRSignoffRequired,
		id: task.id
	};
}

const mapTaskAttributes = (taskAttributes) => {
	return {
		itProcessId: taskAttributes.itProcessId,
		taskName: taskAttributes.title,
		taskNamePrefix: null,
		taskNameSuffix: null,
		knowledgeTaskTitle: null,
		taskTypeId: taskAttributes.taskTypeId,
		taskStatusId: TaskStatusIds.Open,
		itProcessTaskId: taskAttributes.itProcessTaskId,
		isEPTask: false,
		isEQRTask: false,
		id: taskAttributes.taskId
	};
};

const entityNameKeys = {
	itApplications: 'itApplicationName',
	itProcesses: 'itProcessName'
};

const unrelatedFilterAssociatedEntity = {
	itApplications: 'itProcesses',
	itProcesses: 'itApplications'
};

const filterFunctions = {
	searchString: (state, ids, entityName, filterValue) => {
		return filterValue ? ids.filter((id) => state[entityName].byId[id][entityNameKeys[entityName]].toLowerCase().includes(filterValue.toLowerCase())) : ids;
	},
	filterUnassociated: (state, ids, entityName, filterValue) => {
		return filterValue ? ids.filter((id) => state[entityName].byId[id][unrelatedFilterAssociatedEntity[entityName]]?.length === 0) : ids;
	}
};

const filterPriority = {
	searchString: 9,
	filterUnassociated: 0
};
